<p-tabs value="{{activeTabIndex}}" *ngIf="!isOpened">
  <p-tablist style="display: flex; align-items: center;" class="container-style px-0 py-1">
    <p-tab (click)="handleTabChange(0)" value="0">Consulta General</p-tab>
    <p-tab (click)="handleTabChange(1)" value="1">Consulta Detalle</p-tab>
    @if (swOrderModule) {
    <p-tab (click)="handleTabChange(2)" value="2">Consulta Pedidos</p-tab>
    }
    <p-tab (click)="handleTabChange(3)" value="3">Consulta Facturas</p-tab>
    <app-custom-button class="widthBtns" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
      (onClick)="createNewService()" [severity]="'success'" [width]="'5rem'" [variant]="undefined"></app-custom-button>

  </p-tablist>
  <p-tabpanels class="container-style mt-2">
    <p-tabpanel value="0">
      <app-custom-indicators [charts]="indicatorCharts" [loading]="loadingIndicators"></app-custom-indicators>
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="generalHeader" [data]="generalData"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'service'"
        (onRecoverData)="getServicesWithPagination()" (onPageChange)="onPageChange($event)"
        (onReload)="getIndicatorsForGeneralConsultation()" (onFilterChange)="onFilterChange($event)"
        (onExport)="onExport()" (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="detailHeader" [data]="detailData"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'service'"
        (onRecoverData)="getDetailsWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()" (onAction)="onAction($event)">
      </app-custom-table>
    </p-tabpanel>
    @if (swOrderModule) {
    <p-tabpanel value="2">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="remissionFromOrderHeader.columns"
        [data]="remissionFromOrderData" [previousFilters]="filters" [listRemissionOrderState]="listRemissionOrderState"
        [remissionOrderState]="remissionOrderState" [filterPersistentKey]="'service'"
        [actions]="remissionFromOrderActions" (onAction)="onAction($event)"
        (remissionOrderStateEmit)="onRemissionOrderStateChange($event)"
        (onRecoverData)="getAllRemissionFromOrderWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"></app-custom-table>
    </p-tabpanel>
    }
    <p-tabpanel value="3">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="invoiceHeader" [data]="invoiceData"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'service'"
        (onRecoverData)="getAllInvoiceForServicesWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
        (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
<app-custom-modal #orderDataModal [header]="'Datos del Pedido'" [width]="'60vw'"
  [inputs$]="inputsForOrderDataModal$" [children]="componentOrderData" hidden>
</app-custom-modal>

<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>